var HoverSupport          = require("enyo-ui/HoverSupport"),
    IconButton            = require("app/ui/IconButton"),
    ImageSlide            = require("app/ui/ImageSlide"),
    Slider                = require("app/ui/Slider"),
    SliderArraySupport    = require("app/ui/SliderArraySupport"),
    SliderAutoplaySupport = require("app/ui/SliderAutoplaySupport"),
    SliderDrawLoopSupport = require("enyo-ui/SliderDrawLoopSupport"),
    SliderSlideArranger   = require("enyo-ui/SliderSlideArranger"),
    icons                 = require("app/theme/icons"),
    kind                  = require("enyo/kind");

require("app/ui/ImageSlider.less");
require("app/theme/IconButton--slider.less");

/**
 * [ImageSlider]{@link app.ui.ImageSlider} displays a horizontal slideshow of
 * [ImageSlides]{@link app.ui.ImageSlide}.
 *
 * @ui
 * @class    app.ui.ImageSlider
 * @extends  app.ui.Slider
 * @mixes    enyo-ui.SliderArraySupport
 * @mixes    enyo-ui.SliderDrawLoopSupport
 * @mixes    enyo-ui.HoverSupport
 * @mixes    app.ui.SliderAutoplaySupport
 * @public
 */
module.exports = kind(/** @lends  app.ui.ImageSlider.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ImageSlider",

    /**
     * @private
     */
    kind: Slider,

    /**
     * @private
     */
    classes: "app-ui-image-slider",

    /**
     * @private
     */
    mixins: [
        SliderArraySupport,
        SliderDrawLoopSupport,
        HoverSupport,
        SliderAutoplaySupport
    ],

    /**
     * The kind responsible for arranging slides within the slideContainer.
     *
     * @type  {enyo-ui.SliderArranger}
     * @public
     */
    arrangerKind: SliderSlideArranger,

    /**
     * The kind that will be rendered for each record in the dataset.
     *
     * @type  {enyo.Control}
     * @public
     */
    slideKind: ImageSlide,

    /**
     * The amount of slides that will initially be preloaded.
     *
     * @type     {number}
     * @default  10
     * @public
     */
    bufferSize: 10,

    /**
     * Sets the orientation of the slider. The slider will respond to drag
     * gestures along this axis and the arranger may make use of this value
     * as well for animated transitions.
     *
     * Supported values are "vertical" and "horizontal".
     *
     * @type     {string}
     * @default  "horizontal"
     * @public
     */
    axis: "horizontal",

    /**
     * The debounce duration (in ms) between consecutive transitions. If
     * multiple transitions get requested within this time frame, only the
     * first and last one will get executed.
     *
     * @type    {number}
     * @default 250
     * @public
     */
    transitionTimeout: 300,

    /**
     * The kind that will be used for previous button
     *
     * @type  {enyo.Control}
     * @public
     */
    previousButtonKind: IconButton,

    /**
     * Options for the previous button.
     *
     * @type  {Object=}
     * @public
     */
    previousButtonOptions: {
        theme: "slider",
        icon:  icons["app.ui.header.MediaHeader.previousSlideButton"]
    },

    /**
     * The kind that will be used for next button
     *
     * @type  {enyo.Control}
     * @public
     */
    nextButtonKind: IconButton,

    /**
     * Options for the next button.
     *
     * @type  {Object=}
     * @public
     */
    nextButtonOptions: {
        theme: "slider",
        icon:  icons["app.ui.header.MediaHeader.nextSlideButton"]
    },

    /**
     * Toggle button visibility
     *
     * @type  {Object=}
     * @public
     */
    showButtons: true,

    /**
     * @private
     */
    handlers: {
        onRequestPreviousSlide: "onRequestPreviousSlide",
        onRequestNextSlide:     "onRequestNextSlide"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.createPrevButton();
            this.createNextButton();
            this.createSlideClient();
            sup.apply(this, arguments);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.updateButtonVisibility();
        };
    }),

    /**
     * @private
     */
    showButtonsChanged: function() {
        this.updateButtonVisibility();
    },

    /**
     * @private
     */
    lengthChanged: function() {
        this.updateButtonVisibility();
    },

    /**
     * @private
     */
    updateButtonVisibility: function() {
        var showButtons = this.get("showButtons"),
            length      = this.get("length"),
            shouldShow;

        shouldShow = showButtons && length > 1;
        this.$.previousButton.set("showing", shouldShow);
        this.$.nextButton.set("showing", shouldShow);
    },

    /**
     * @private
     */
    createPrevButton: function() {
        var previousButtonOptions = this.previousButtonOptions || {};
        this.createComponent({
            name:    "previousButton",
            kind:    this.get("previousButtonKind"),
            classes: "app-ui-image-slider__previous-button " + (previousButtonOptions.classes || ""),
            showing: false,
            ontap:   "onRequestPreviousSlide"
        }, previousButtonOptions);
    },

    /**
     * @private
     */
    createNextButton: function() {
        var nextButtonOptions = this.nextButtonOptions || {};
        this.createComponent({
            name:    "nextButton",
            kind:    this.get("nextButtonKind"),
            classes: "app-ui-image-slider__next-button " + (nextButtonOptions.classes || ""),
            showing: false,
            ontap:   "onRequestNextSlide"
        }, nextButtonOptions);
    },

    /**
     * @private
     */
    createSlideClient: function() {
        this.createComponent({
            name:    "client",
            classes: "app-ui-image-slider__client enyo-fit",
            chrome:  true
        });
    },

    /**
     * @returns  {boolean}  Stop event propagation
     * @private
     */
    onRequestPreviousSlide: function() {
        var autosliding = this.slideShowTimer;

        autosliding && this.slideShowStop();
        this.transitionToPrevious();
        autosliding && this.slideShowStart();

        return true;
    },

    /**
     * @returns  {boolean}  Stop event propagation
     * @private
     */
    onRequestNextSlide: function() {
        var autosliding = this.slideShowTimer;

        autosliding && this.slideShowStop();
        this.transitionToNext();
        autosliding && this.slideShowStart();

        return true;
    }

});
